/* eslint-disable */
import { isFalsePositiveMessage } from './helpers';

if (!window.onerror) {
    window.addEventListener('error', event => {
        const { message } = event;

        if (isFalsePositiveMessage(message)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    });
}
